import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { Team } from 'app/models/team';
import { User } from 'app/models/user';
import { StorageService } from 'app/services/storage.service';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';


@Component({
  selector: 'app-add-sftpstorage',
  templateUrl: './add-sftpstorage.component.html',
  styleUrls: ['./add-sftpstorage.component.scss']
})
export class AddSFTPStorageComponent implements OnInit {
  sftpForm: FormGroup;
  storageId: number;
  loading: boolean = false;
  connectionMsg: string = "";
  isNgSelectLoading: boolean = false;
  
  constructor(private validationHandler: ValidationHandler,
    public storageService: StorageService, private navigateRoute: Router,
    private toastService: ToastService, private _route: ActivatedRoute,
    public tagService: TagService, private ecoDocsTitleService: EcoDocsTitleService) {

    //Validate From for Submition 
    this.sftpForm = this.storageService.getSFTPFormGroup();


    //Get FTP driver for edit 
    this._route.params.subscribe(params => {
      if (params.storageid) {
        this.storageId = +params.storageid;
        this.loading = true;
        storageService.getById(this.storageId).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(f => {
          this.sftpForm.patchValue(f);
        });
      }
    });
  }


  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Add SFTP Storage', false );
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  showPassword(input) {
    if (input.type == "text") {
      input.type = "password"
    }
    else {
      input.type = "text"
    }
  }
  submit(frm: FormGroup) {
    this.loading = true;

    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      this.loading = false;
      return;
    }

    if (this.storageId) {
      this.storageService.updateSftp(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, (err) => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
    else {
      this.storageService.addSftp(frm.value).subscribe(t => {
        this.loading = false;
        this.navigateRoute.navigateByUrl('/manage/storage')
      }, err => {
        this.loading = false;
        if (err.status === 422) {
          this.validationHandler.serverValidationHandler(err, frm);
        }
        else
          this.toastService.error("Save Failed");
      });
    }
  }

  testConnection(frm: FormGroup) {
    if (!frm.valid) {
      this.validationHandler.onSubmitCheck(frm);
      return;
    }

    this.loading = true;
    this.storageService.sftpTestConnection(frm.value).pipe(finalize(() => {
      this.loading = false;
    })).subscribe(t => {
      this.toastService.success("Connection Succeeded!");
    }, err => {
      if (err.status === 422) {
        this.validationHandler.serverValidationHandler(err, this.sftpForm);
      }
      else {
        this.toastService.error("Connection Failed!");
      }
    });
  }

}
